"use client";

import Image from "next/image";
import type { CSSProperties, MouseEventHandler } from "react";

type SliderArrowProps = {
  className?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  imageUrl?: string;
  imageAlt?: string;
  direction: "prev" | "next";
  rotatePrev?: boolean;
};

export default function SliderArrow({
  className,
  style,
  onClick,
  imageUrl,
  imageAlt,
  direction,
  rotatePrev = false,
}: SliderArrowProps) {
  if (!imageUrl) {
    return null;
  }

  return (
    <button
      type="button"
      className={className || ""}
      style={{
        ...style,
        [direction === "prev" ? "left" : "right"]: "10px",
        zIndex: 10,
        width: "40px",
        height: "40px",
        transform:
          direction === "prev" && rotatePrev
            ? "rotate(180deg)"
            : style?.transform,
      }}
      onClick={onClick}
      aria-label={imageAlt || (direction === "prev" ? "Previous" : "Next")}
    >
      <Image
        src={imageUrl}
        alt=""
        aria-hidden="true"
        width={100}
        height={100}
        style={{ width: "100%", height: "100%", pointerEvents: "none" }}
      />
    </button>
  );
}
